import { get } from 'lodash';
export default function isExperimentEnabled(experiments, experiment, value) {
    if (value === void 0) { value = 'true'; }
    var values = Array.isArray(value) ? value : [value];
    return values.includes(get(experiments, experiment));
}
